import { Box, Card, CircularProgress, Container, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import CoinTransactionsTable from "src/components/transactions-table/CoinTransactionsTable";
import { get } from "src/utils/networkUtils";
import Scrollbar from "../components/scrollbar";

export default function CoinTransactionsPage() {
	const [loading, setLoading] = useState(false);
	const [rows, setRows] = useState(null);

	useEffect(() => {
		get(`/admin/coins/transactions?offset=0&limit=100`).then((response) => {
			setLoading(false);
			setRows(response.transactions);
		});
	}, []);

	return (
		<>
			<Helmet>
				<title> Coins Transactions </title>
			</Helmet>

			<Container>
				<Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
					<Typography variant="h4" gutterBottom>
						Coin Transactions
					</Typography>
				</Stack>

				<Card>
					{rows === null || loading ? (
						<Box sx={{ display: "flex", justifyContent: "center" }} style={{ padding: 20 }}>
							<CircularProgress />
						</Box>
					) : (
						<Scrollbar>
							<CoinTransactionsTable transactions={rows} />
						</Scrollbar>
					)}
				</Card>
			</Container>
		</>
	);
}
